import { render, staticRenderFns } from "./depositPrint.vue?vue&type=template&id=0889c105&scoped=true"
import script from "./depositPrint.vue?vue&type=script&lang=js"
export * from "./depositPrint.vue?vue&type=script&lang=js"
import style0 from "./depositPrint.vue?vue&type=style&index=0&id=0889c105&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889c105",
  null
  
)

export default component.exports